import { formatPrice } from 'utils/general'
import { escapeRegex } from 'utils/gw'
import { dispatchAnalyticsEvent, addEventAnalytics } from 'utils/_analytics'
import { getElementLabel } from 'utils/dom'
import { ElementValidator } from 'utils/_validation'
// TODO: Ensure events aren't triggering twice after logging in

/**
 * Event dispatch
 */

/* Customer Login event */
addEventAnalytics('gw-customer-accounts:login', 'cstm_account_login')

/* Customer Logout event */
addEventAnalytics('gw-customer-accounts:logout', 'cstm_account_logout')

/* Accordion Expand event */
addEventAnalytics('accordion:open', 'cstm_accordion_expand')

// Filter View event
addEventAnalytics('filter:apply', 'cstm_filter_view')

// Country Select event
addEventAnalytics('localization-country:select', 'cstm_country_select_interact', {
  label: 'Localization Country Select',
})

// Form Error event
addEventAnalytics('form:error', 'cstm_form_error')

// Gallery Change event
addEventAnalytics('gallery:change')

// TODO: Store all triggering
const CTA_VALIDATION_CRITERIA = {
  valid: {
    class: ['button', 'two-columns__item--overlay--link'],
    // properties: {
    //   textContent: [/^\s*shop [\w -]+\s*$/i, /^\s*discover [\w -]+\s*$/i],
    // },
    label: [/^\s*shop [\w -]+\s*$/i, /^\s*discover [\w -]+\s*$/i],
  },
  invalid: {
    class: ['js-anchor', 'button--plain'],
    attributes: {
      href: [
        '#',
        '#0',
        'javascript:void(0)',
        new RegExp(
          `^https?://(?!(?:[a-z]+\.)?(?:${escapeRegex(
            window.location.hostname.replace('www.', '')
          )}|${escapeRegex(Shopify.shop)}))`
        ),
      ],
    },
  },
}

const isNavItem = (link) => {
  if (link.closest('nav') || link.closest('[role="navigation"]')) return true
  // if (link.role === 'menuitem') return true

  return false
}

/* CTA Click event */
document.body.addEventListener('click', (e) => {
  const link = e.target.closest('a')
  if (!link) return

  let event_key, event_label
  if (isNavItem(link)) {
    event_key = 'cstm_item_navigation_click'
    event_label = 'Navigation Link Click'
  } else if (ElementValidator.validate(link, CTA_VALIDATION_CRITERIA)) {
    event_key = 'cstm_cta_click'
    event_label = 'CTA Click'
  }

  if (!event_key) return

  const url = link.href.trim()
  const label = getElementLabel(link)
  if (!label) return

  const eventData = { label, url }

  dispatchAnalyticsEvent(event_key, eventData, { label: event_label })
})

/* Variant Change event */
const VARIANT_CHANGE_OPTION_POSITION = 1
document.addEventListener('variant:change', (e) => {
  const optionKey = `option${VARIANT_CHANGE_OPTION_POSITION}`
  const {
    detail: { variant, optionKeyMap },
  } = e

  if (!variant?.[optionKey]) return

  const product_name = variant.name.replace(` - ${variant.title}`, '')
  const product_sku = variant.sku
  const product_price = formatPrice(variant.price, 2, '')
  const selection_value = variant[optionKey]
  const selection_type = optionKeyMap[optionKey]

  const eventData = {
    selection_type,
    selection_value,
    product_name,
    product_sku,
    product_price,
  }

  dispatchAnalyticsEvent('cstm_item_variant_select', eventData)
})

document.addEventListener(
  'wishlist:add',
  ({ detail: { product, variant } }) => {
    if (!product) {
      console.error(
        'Failed to dispatch wishlist:add event. No product data provided.'
      )
      return
    }

    const { title: product_name } = product

    if (!product_name) return

    let eventData = { product_name }

    if (variant) {
      const { sku: product_sku } = variant
      const product_price = formatPrice(variant.price, 2, '')

      eventData = { ...eventData, product_sku, product_price }
    } else {
      console.warn(
        'Dispatching wishlist:add event without variant data. No SKU or price will be sent.'
      )
    }

    dispatchAnalyticsEvent('cstm_add_wishlist', eventData)
  }
)

document.addEventListener('DOMContentLoaded', () => {
  function cartIntercept() {
    let previousFetch = window.fetch;

    function getCartAction(url) {
      if (/\/cart\/add/i.test(url)) return 'add';
      if (/\/cart\/change/i.test(url)) return 'change';
      if (/\/cart\/update/i.test(url)) return 'update';
      return null;
    }

    window.fetch = async function (resource, init) {
      const url = typeof resource === 'string' ? resource : resource.url;
      const action = getCartAction(url);

      if (action) {
        document.dispatchEvent(new CustomEvent('cart:intercept', { detail: { action, url } }))
        console.debug('[Cart Intercept] fetch call to', action);
      }

      const response = await previousFetch.apply(this, arguments);

      if (action) {
        try {
          const data = await response.clone().json();
          document.dispatchEvent(new CustomEvent('cart:intercept', { detail: { action, url, data, response } }))
          console.debug('[Cart Intercept] response for', action, data);
        } catch (e) { }
      }

      return response;
    };
  }

  cartIntercept()
});